import * as React from 'react';
import { PriceSummaryProps } from './PriceSummary.types';
import { Modal, ModalSize } from '../Modal';
import './styles/PriceSummary.css'; 

export const PriceSummary = ({
    price,
    children
}: PriceSummaryProps): JSX.Element => {
    const [ showDiscounts, setShowDiscounts ] = React.useState(false);
    return ( 
        <div className="price-summary">
            <div className="price-summary__total">
                <div className="price-summary__price">
                    &pound;{price && (price / 100).toFixed(2)}
                </div>
                <a 
                    href="#" 
                    className="price-summary__discounts btn"
                    onClick={() => setShowDiscounts(true)}  
                > 
                    Click here for <br /> QUANTITY DISCOUNT PRICES
                </a>
                <Modal
                    show={showDiscounts}
                    onChange={(show: boolean) => setShowDiscounts(show)}
                    size={ModalSize.Small}
                >
                    <h1>Cart Discounts</h1>
                    <div className="tiered-pricing">
                        {children}
                    </div>
                </Modal>
            </div>
        </div>
        
    );
};